import React from "react";
import Button from "../common/Button";
import Audio from "../common/Audio";
import ToolTipDropDown from "./ToolTipDropDown";
import getTimeCodeFromNum from "../util/getTimeCode";
import { ModalType } from "../Modal";
import Loader from "../common/Loader";
import SearchBar from "../SearchBar";
const PlayerHeader = ({
  goToListItem,
  isLoadingAudio,
  handleOpenModal,
  currentReciter,
  currentPlaying,
  onIsAllLoopActive,
  isAllLoopActive,
  currentSelected,
  favSize,
  searchQuery,
  chaptersCount,
  recitersList,
  quranChapters,
  audioSrc,
  audioRef,
  audioCurrentTime,
  audioLength,
  currentVolume,
  isPlaying,
  isOptionsListDropdownOpen,
  isActiveLoop,
  isFavList,
  isActiveRecitersDropdown,
  timelineProgressRef,
  mainGraphicSrc,
  toggleDropdown,
  handleRandomChapter,
  handlePrevChapter,
  handleLoop,
  handleFav,
  handleNextChapter,
  handleVolume,
  handleSeek,
  handleCurrentReciter,
  showFavList,
  showAllChaptersList,
  handlePlayPause,
  toggleOptionsDropdown,
  toggleMute,
  dispatch,
}) => {
  return (
    <div className="player-header">
      <div className="dropdown is-hoverable">
        <div className="dropdown-trigger">
          <h2 className={isPlaying ? "title playing" : "title"}>
            {currentPlaying.name}

            <a
              href={`#${currentPlaying.order - 1}`}
              onClick={(e) => {
                e.preventDefault();
                goToListItem(currentPlaying.order - 1);
              }}
            >
              <span className="icon is-medium">
                <i className="fa fa-link" />
              </span>
            </a>
          </h2>
        </div>
        <ToolTipDropDown
          content={`انتقال الى السورة الحالية رقم - ${currentPlaying.order} -`}
        />
      </div>

      {/*----------------------------------------------------- */}
      {/*onBlur={() => {
              if (isActiveRecitersDropdown) toggleDropdown();
            }}*/}

      <div className="reciters-dropdown ">
        <div className="dropdown">
          <button
            onClick={toggleDropdown}
            className={`dropbtn ${isActiveRecitersDropdown ? "active" : ""}`}
          >
            <span className={isPlaying ? "subtitle playing" : "subtitle"}>
              القارئ <em>{currentReciter.name}</em>
            </span>
          </button>

          <div
            className={`dropdown-content ${
              isActiveRecitersDropdown ? " show " : " "
            }`}
          >
            <SearchBar
              onSearch={(e) => {
                console.log("searching for reciter...");
              }}
              onClearSearch={(e) => {
                console.log("clearing search...");
              }}
              searchQuery=""
              placeholderText="بحث عن قارئ..."
            />
            {recitersList.map((rctr, index) => {
              return (
                <a
                  onClick={() => {
                    handleCurrentReciter(index);
                  }}
                  key={index}
                  className={
                    currentReciter.name === rctr.name ? "is-active" : ""
                  }
                >
                  <span>{rctr.name}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
      {/*----------------------------------------------------- */}
      <div className="player-controls is-flex is-align-items-center is-justify-content-center is-flex-grow-1">
        <Button
          handleClick={() => {
            handleFav(currentPlaying);
          }}
          classList="button active-fav"
          title={`{${favSize}} مفضلة`}
        >
          <span className="icon is-medium">
            <i
              className={currentPlaying.isFav ? "fa fa-heart" : "fa fa-heart-o"}
            />
          </span>
        </Button>

        <div className="dropdown is-hoverable">
          <div className="dropdown-trigger">
            <Button classList="button" handleClick={handleLoop}>
              <span className="icon is-medium">
                <i
                  className={
                    isActiveLoop ? "fa fa-repeat active-repeat" : "fa fa-repeat"
                  }
                />
              </span>
            </Button>
          </div>

          <ToolTipDropDown content="تشغيل تكرار السورة" />
        </div>

        <div className="dropdown is-hoverable">
          <div className="dropdown-trigger">
            <Button
              classList="button active-prev"
              handleClick={handlePrevChapter}
            >
              <span className="icon is-medium">
                <i className="fa fa-step-backward" />
              </span>
            </Button>
          </div>
          <ToolTipDropDown
            content={
              quranChapters && quranChapters.length > 0
                ? currentSelected.order - 1 !== 0
                  ? quranChapters[currentSelected.order - 2].name
                  : quranChapters[quranChapters.length - 1].name + " ￩ "
                : ""
            }
          />
        </div>

        <div
          className="play-btn"
          onClick={() => {
            if (!isLoadingAudio) handlePlayPause(currentPlaying);
          }}
        >
          {" "}
          <div className={isPlaying ? "icon play" : "icon pause"}>
            {isLoadingAudio ? (
              <figure className="image is-96x96">
                <Loader
                  className="header-play-btn-loader-indicator is-rounded "
                  width="96"
                  height="96"
                />
              </figure>
            ) : (
              <figure className="image is-96x96">
                <img
                  className={isPlaying ? "is-rounded rotate-cd" : "is-rounded "}
                  src={mainGraphicSrc}
                />
              </figure>
            )}{" "}
          </div>
        </div>

        <div className="dropdown is-hoverable">
          <div className="dropdown-trigger">
            <Button
              classList="button active-next"
              handleClick={handleNextChapter}
            >
              <span className="icon is-medium">
                <i className="fa fa-step-forward" />
              </span>
            </Button>
          </div>
          <ToolTipDropDown
            content={
              quranChapters && quranChapters.length > 0
                ? currentSelected.order >= quranChapters.length
                  ? quranChapters[0].name
                  : quranChapters[currentSelected.order].name + " ￩"
                : ""
            }
          />
        </div>
        <div className="dropdown is-hoverable">
          <div className="dropdown-trigger">
            <Button
              classList="button active-random"
              handleClick={handleRandomChapter}
            >
              <span className="icon is-medium">
                <i className="fa fa-random" />
              </span>
            </Button>
          </div>
          <ToolTipDropDown content="سورة عشوائية" />
        </div>
        <div
          className={
            isOptionsListDropdownOpen ? "dropdown is-active" : "dropdown"
          }
        >
          <div className="dropdown-trigger">
            <div className="options">
              <Button
                handleClick={toggleOptionsDropdown}
                classList="button is-info is-outlined"
              >
                <span className="icon is-small">
                  <i className="fa fa-th-list" />
                </span>
              </Button>
            </div>
          </div>
          <div className="dropdown-menu">
            <div className="dropdown-content">
              <a
                className={`dropdown-item ${isFavList ? "is-active" : ""}`}
                onClick={() => {
                  showFavList();
                  toggleOptionsDropdown();
                }}
              >
                {isFavList
                  ? `(${favSize}) ¤ إخفاء المفضلة`
                  : `(${favSize}) ¤ إضهار المفضلة`}

                <span className="icon is-medium">
                  <i
                    className={`fa ${isFavList ? "fa-heart" : "fa-heart-o"}`}
                  />
                </span>
              </a>
              <a
                onClick={() => {
                  showAllChaptersList();
                  toggleOptionsDropdown();
                }}
                className={`dropdown-item ${
                  !isFavList && !searchQuery ? "is-active" : ""
                }`}
              >
                قائمة السور ¤ ({chaptersCount})
                <span className="icon is-medium">
                  <i className="fa fa-list" />
                </span>
              </a>
              <hr className="dropdown-divider" />
              <a
                onClick={(e) => {
                  e.preventDefault();
                  onIsAllLoopActive();
                  toggleOptionsDropdown();
                }}
                className={`dropdown-item ${
                  isAllLoopActive ? "is-active" : ""
                }`}
                target="_blank"
                download
              >
                تبديل تلقائي للسور
                <span className="icon is-medium">
                  <i className="fa fa-step-forward" />
                </span>
              </a>{" "}
              {/*
              <a
                href={audioSrc}
                className="dropdown-item"
                target="_blank"
                download
              >
                إيقاف السورة
                <span className="icon is-medium">
                  <i className="fa fa-stop-circle-o" />
                </span>
              </a>*/}
              <a
                href={audioSrc}
                className="dropdown-item"
                target="_blank"
                onClick={()=>{
                  toggleOptionsDropdown();
                }}
                download
              >
                تحميل السورة
                <span className="icon is-medium">
                  <i className="fa fa-download" />
                </span>
              </a>
              <hr className="dropdown-divider" />
              <a
                onClick={() => {
                  handleOpenModal(ModalType.RECITER_INFO);
                  toggleOptionsDropdown();
                }}
                className="dropdown-item"
              >
                معلومات حول القارئئ
                <span className="icon is-medium">
                  <i className="fa fa-question-circle" />
                </span>
              </a>
              <a
                onClick={() => {
                  handleOpenModal(ModalType.CHAPTER_INFO);
                  toggleOptionsDropdown();
                }}
                className="dropdown-item"
              >
                معلومات حول السورة
                <span className="icon is-medium">
                  <i className="fa fa-question-circle" />
                </span>
              </a>
              <hr className="dropdown-divider" />
              <a
                onClick={() => {
                  handleOpenModal(ModalType.APP_ABOUT);
                  toggleOptionsDropdown();
                }}
                className="dropdown-item"
              >
                حول التطبيق
                <span className="icon is-medium">
                  <i className="fa fa-info-circle" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/*----------------------------------------------------- */}

      <div className={isPlaying ? "time is-playing" : "time"}>
        <span className="current">{getTimeCodeFromNum(audioCurrentTime)}</span>
        <span className="divider">/</span>
        <span className="length">{getTimeCodeFromNum(audioLength)}</span>
      </div>

      {/*----------------------------------------------------- */}
      <div className="volume-container">
        <div className="volume-button" onClick={toggleMute}>
          <i
            className={`volume  fa-2x fa ${
              currentVolume > 0 ? "fa-volume-up" : "fa-volume-off"
            }`}
          />
        </div>

        <div className="volume-slider" onClick={handleVolume}>
          <div
            className="volume-percentage"
            style={{ width: `${currentVolume * 100}%` }}
          />
        </div>
      </div>
      {/*----------------------------------------------------- */}
      <div className="timeline" onClick={handleSeek}>
        <div className="progress" ref={timelineProgressRef} />
      </div>
      {/*----------------------------------------------------- */}
      <Audio audioSrc={audioSrc} audioRef={audioRef} dispatch={dispatch} />
    </div>
  );
};

export default PlayerHeader;
